import { render, staticRenderFns } from "./personal-info.vue?vue&type=template&id=87ce642c&"
import script from "./personal-info.vue?vue&type=script&lang=js&"
export * from "./personal-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports